import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              TekRevol: A Future-Oriented Software Development Company in UK
            </h2>
            <p>
              Ranked among the premier software development companies in UK,
              TekRevol proudly showcases unparalleled expertise in software
              development. Our commitment to excellence extends to pioneering
              innovations and unique functionalities, supported by cutting-edge
              coding practices that set industry standards.
            </p>
            <p>
              Establishing a strong presence as a custom software development
              company, we propel businesses toward success through revolutionary
              <Link to="/uk">
                {" "}
                digital transformation solutions and consultations.
              </Link>{" "}
              Leveraging innovative technology, we foster the growth of
              businesses, enhancing their competitive edge. Embark on your
              digital journey with us today. Let's revolutionize industries and
              distinguish your business in the ever-evolving digital landscape.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/location_new/fold11/Uk.webp"
              alt="Android-app-development-companies-london"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={670}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
